import { useState, useEffect } from "react";
import "react-dropdown/style.css";
import { useHistory, useLocation } from "react-router-dom";
import "./tool-dropdown.scss";
import generatorLogo from "../../../assets/landingpage/Glogo.svg";
import s2rLogo from "../../../assets/landingpage/SRlogo.svg";
import useOuterClick from "../../Hooks/useOuterClick";

const generatorOption = (
  <div>
    <img
      alt="logo"
      style={{
        width: "2rem",
        height: "2rem",
        marginRight: "1rem",
      }}
      src={generatorLogo}
    ></img>
    Generator mobile
  </div>
);

const s2rOption = (
  <div>
    <img
      alt="logo"
      style={{
        width: "2rem",
        height: "2rem",
        marginRight: "1rem",
      }}
      src={s2rLogo}
    ></img>
    S2R mobile
  </div>
);

export default function ReactDropdown() {
  const history = useHistory();
  const location = useLocation();
  const [showDropdown, setShowDropdown] = useState(false);
  const [dropDownOption, setDropDownOption] = useState(
    location.pathname === "/generator" ? generatorOption : s2rOption
  );
  const innerRef = useOuterClick((ev) => {
    if (showDropdown) setShowDropdown(false);
  });

  return (
    <>
      <div
        onClick={() => {
          setShowDropdown(!showDropdown);
        }}
        className="dropdown"
      >
        <div className="dropbtn">
          {dropDownOption}
          {showDropdown ? (
            <i className="fa fa-caret-up"></i>
          ) : (
            <i className="fa fa-caret-down"></i>
          )}
        </div>
        {showDropdown && (
          <div ref={innerRef} className="dropdowncontent">
            <a
              onClick={() => {
                setDropDownOption(s2rOption);
                history.push("/s2r");
              }}
            >
              <img
                alt="logo"
                style={{
                  width: "2rem",
                  height: "2rem",
                  marginRight: "1rem",
                }}
                src={s2rLogo}
              ></img>
              S2R mobile
            </a>
            <a
              onClick={() => {
                setDropDownOption(generatorOption);
                history.push("/generator");
              }}
            >
              <img
                alt="logo"
                style={{
                  width: "2rem",
                  height: "2rem",
                  marginRight: "1rem",
                }}
                src={generatorLogo}
              ></img>
              Generator mobile
            </a>
          </div>
        )}
      </div>
    </>
  );
}
